import React from 'react';
import { Link } from 'react-router-dom';
import './AgendaPage.css';

const items = [
  { n: 1, title: 'NDA' },
  { n: 2, title: 'ISTAND' },
  { n: 3, title: 'Mayo' },
  { n: 4, title: 'NeXus AI' },
];

function AgendaPage() {
  const bannerStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/assets/NeXusNeroClinical_mit.webp)`,
  };

  return (
    <main className="agenda-page">
      <section className="agenda-banner" style={bannerStyle}>
        <div className="agenda-banner-overlay">
          <Link to="/" className="agenda-back">&larr; Home</Link>
          <img
            src="/assets/nexus_neuro_logo.webp"
            alt="NeXus NeuroInformatics, Inc."
            className="agenda-banner-logo"
          />
          <h1 className="agenda-banner-title">Meeting Agenda</h1>
        </div>
      </section>

      <header className="agenda-meta">
        <dl className="agenda-meta-list">
          <div>
            <dt>Date</dt>
            <dd>&mdash;</dd>
          </div>
          <div>
            <dt>Attendees</dt>
            <dd>&mdash;</dd>
          </div>
          <div>
            <dt>Chair</dt>
            <dd>Marjorie McCubbins</dd>
          </div>
        </dl>
      </header>

      <section className="agenda-body">
        <ol className="agenda-list">
          {items.map((item) => (
            <li key={item.n} className="agenda-item">
              <span className="agenda-num">{String(item.n).padStart(2, '0')}</span>
              <div className="agenda-content">
                <h2 className="agenda-h2">{item.title}</h2>
              </div>
            </li>
          ))}
        </ol>
      </section>
    </main>
  );
}

export default AgendaPage;
